import React, { useState, useRef, useCallback, useEffect } from 'react';
import { Popup, ScrollView, Button } from '../../components/BootstrapControls';
import Axios from '../../api/axios';
import notify from '../../utils/notifyUtil';
import Dict from '../../messages.js';
import * as glb from '../../globals.js';
import CariAramaPanel from '../../components/cari/CariAramaPanel.js';
import LoadingElapsed from '../../components/LoadingElapsed.js';

export default function AramaGirPanel({ carRef, carAdSoy, visible, onHiding, embedded = false, onListChange }) {
    const [loading, setLoading] = useState(false);
    const [cariAramaList, setCariAramaList] = useState([]);
    const [cariData, setCariData] = useState(null);
    const [screen, setScreen] = useState(null);
    const hasLoadedRef = useRef(false);
    const isMountedRef = useRef(true);

    useEffect(() => {
        isMountedRef.current = true;
        return () => { isMountedRef.current = false; };
    }, []);

    const fetchAramaData = useCallback(async () => {
        if (!carRef) return;

        setLoading(true);
        try {
            // console.log('Fetching arama data for carRef:', carRef);
            
            // Fetch cari data
            const cariRes = await Axios.get(`${process.env.REACT_APP_BACKEND_SERVER}CARI_KART/rec?pnm=CARI_KART&CAR_REF=${carRef}&cid=${glb.default.KULLANICI.KUL_DEF_FIR_REF}`);
            
            // console.log('Cari response:', cariRes.data);
            
            if (cariRes.data && !cariRes.data.iserr) {
                const data = cariRes.data.carikart || cariRes.data;
                const aramaList = cariRes.data.cariAramaList || [];
                
                // console.log('Arama list:', aramaList);
                
                if (isMountedRef.current) {
                    setCariData(data);
                    setCariAramaList(aramaList);
                    
                    // Get screen info
                    const screenData = glb.default.EKRANLkp?.find(x => x.EKR_EKRANADI === 'AramaGirPanel');
                    // console.log('Screen data:', screenData);
                    setScreen(screenData || { EKLE: true, DUZELT: true, SIL: true });
                }
            } else {
                // console.log('Cari data not found or error');
                if (isMountedRef.current) {
                    notify(Dict.get('anyItemNotFound'), 'warning', 1000);
                }
            }
        } catch (err) {
            console.error('Error fetching arama data:', err);
            if (isMountedRef.current) {
                notify(Dict.get('error') + ': ' + (err.response?.data?.message || err.message), 'error', 3000);
            }
        } finally {
            if (isMountedRef.current) setLoading(false);
        }
    }, [carRef]);

    useEffect(() => {
        if (visible && carRef && !hasLoadedRef.current) {
            hasLoadedRef.current = true;
            fetchAramaData();
        }
        if (!visible) {
            hasLoadedRef.current = false;
        }
    }, [visible, carRef, fetchAramaData]);

    const handleListChange = useCallback((newList) => {
        setCariAramaList(newList);
        onListChange?.(newList);
    }, [onListChange]);

    const handleClose = useCallback(() => {
        onHiding?.();
    }, [onHiding]);

    const content = (
        <div style={{ padding: '10px', height: '100%', display: 'flex', flexDirection: 'column' }}>
            {loading ? (
                <div style={{ textAlign: 'center', padding: '20px' }}>
                    <LoadingElapsed text={Dict.get('Yükleniyor...')} />
                </div>
            ) : cariData ? (
                <div style={{ flex: 1, overflow: 'auto' }}>
                    <CariAramaPanel
                        carRef={carRef}
                        cariAramaList={cariAramaList}
                        onListChange={handleListChange}
                        formData={cariData}
                        isNewRecord={false}
                    />
                </div>
            ) : (
                <div style={{ textAlign: 'center', padding: '20px', color: 'red' }}>
                    {Dict.get('Veri yüklenemedi')} - Console'da hata detaylarını kontrol edin
                </div>
            )}
        </div>
    );

    if (embedded) return visible ? content : null;

    return (
        <Popup
            visible={visible}
            onHiding={handleClose}
            dragEnabled={false}
            hideOnOutsideClick={false}
            showCloseButton={true}
            showTitle={true}
            title={`Arama Gir ${carRef && carAdSoy ? `(${carRef} - ${carAdSoy})` : ''}`}
             width="100%"
            height="100%"
        >
            <ScrollView width="100%" height="100%">{content}</ScrollView>
        </Popup>
    );
}
